import { ConfigStepperClass, ConfigStepperComponentClass } from './dynamicpdf-class';
import { PaymentsSplitClass, PaymentsTypesClass, ProductsProposalsPaymentsSplitClass } from './payments-class';
import { ObterResultadosSimulacaoRVHObjJsonResultClass } from './realvida-class';
import { Robotclass } from './robot-class';
import { FilesClass } from './uploads-class';
import dayjs, { Dayjs } from 'dayjs';

export class SafesimulationsClass {
  idSafeSimulations: number | null = null;
  idInsurancePolicy?: number | null = null;
  idCustomer?: number | null = null;
  CustomerName: string = '';
  idCompanie?: number | null = null;
  CompanieName: string = '';
  CompaniesShortName: string = '';
  IsCompany: boolean | null = null;
  idProduct?: number | null = null;
  idCommonNIFType: number | null = null;
  ProductsName: string = '';
  ProductShortName: string = '';
  idProductsTypes: number | null = null;
  idPaymentsTypes: number | null = null;
  idCommonEntityType: number | null = null;
  idProductsTypesProposalsPaymentsSplit: number | null = null;
  idProductsTypesProposalsFilter: number | null = null;
  paymentsTypesName: string = '';
  ProductsTypesName: string = '';
  ProductsTypesShortName: string = '';
  BackgroundColor: string = '';
  TextColor?: string = '';
  idPaymentsSplit?: number | null = null;
  PaymentsSplitDescription: string = '';
  idSafeSimulationsStatusTypes?: number | null = null;
  SafeSimulationsStatusTypesDescription: string = '';
  SafeSimulationsStatusTypesBackground: string = '';
  SafeSimulationsStatusTypesTextColor: string = '';
  IconURLStatus: string = '';
  idCommercial?: number | null = null;
  CommercialName: string = '';
  idBillingAddress: number | null = null;
  idShipToAddress: number | null = null;
  AddressDetail: string = '';
  PostalCode: string = '';
  Region: string = '';
  PostalCodeRegion: string = '';
  PolicyNumber: string = '';
  Description: string = '';
  Matricula: string = '';
  Capital: number | null = null;
  Salario: number | null = null;
  showSignature: boolean = false;
  Signature: string = '';
  Observations?: string = '';
  Signature2: string = '';
  CreatedByUser?: number | null = null;
  DateStartPolicy: any = dayjs.utc().add(1, 'day').startOf('day');
  DateEndPolicy: any | null = null;
  Price: number | null = null;
  AcceptContract = 0;
  AcceptRGPD = 0;
  VolumeFaturacao?: string | null = null;
  DateStart: any | null = null;
  DateEnd: any | null = null;

  /**
   * Converte propriedades de data (strings vindas da API) em objetos Dayjs
   */
  public parseDates() {
    const dateFields = [
      'DateStartPolicy',
      'DateEndPolicy',
      'DateStart',
      'DateEnd',
      'DataInicoContrato',
      'Birthdate',
      'CCDateValidate',
      'DrivinglicenseDate',
      'DrivinglicenseExpirationDate',
      'PetBirthdate',
      'AutorizacaoDebitoData',
      'AutoVehiclePlateDate',
      'ArrivalDate',
      'IntermundialStartDate',
      'IntermundialEndDate',
      'DtNasc1PSeg',
      'DtNasc2PSeg',
    ];
    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const d = dayjs.utc(this[f]);
        if (d.isValid()) {
          this[f] = d;
        }
      }
    });

    // Sincronizar propriedades de data de início (compatibilidade entre componentes)
    if (this.DataInicoContrato && !this.DateStartPolicy) {
      this.DateStartPolicy = this.DataInicoContrato;
    } else if (this.DateStartPolicy && !this.DataInicoContrato) {
      this.DataInicoContrato = this.DateStartPolicy;
    }

    // Sincronizar VolumeFaturacao com Atributo1 apenas para produtos RC Exploração
    const isOpenCompExplora = this.OpenComponent?.toLowerCase().includes('explora');
    const isProdNameExplora = this.ProductsTypesName?.toLowerCase().includes('explora');
    if (isOpenCompExplora || isProdNameExplora) {
      if (this.Atributo1 && !this.VolumeFaturacao) {
        this.VolumeFaturacao = this.Atributo1;
      } else if (this.VolumeFaturacao && !this.Atributo1) {
        this.Atributo1 = this.VolumeFaturacao;
      }
    }

    // Sincronizar Versao com AutoVehicleVersion (para tickets e cotações automóvel)
    const versaoSinc = ((this.AutoVehicleVersion || (this as any).Versao || '') as string).trim();
    if (versaoSinc) {
      this.AutoVehicleVersion = versaoSinc;
      this.Versao = versaoSinc;
    }

    // Cast numérico para campos de embarcações (alinhamento strict equality === com mat-select)
    const vesselNumFields = [
      'idCommonVesselsType',
      'idCommonVesselsHullMaterial',
      'idCommonVesselsTonnage',
      'idCommonVesselsNavigationZone',
      'VesselsLotacao',
      'VesselsPotencia',
      'VesselsAnoConstrucao',
    ];
    vesselNumFields.forEach(f => {
      if (this[f] != null && (this[f] as any) !== '') {
        this[f] = Number(this[f]);
      }
    });

    // Normalizar HouseDidPlumbingElectricityWork para string '1' ou '0' (compatibilidade strict equality com mat-button-toggle-group)
    if (
      this.HouseDidPlumbingElectricityWork !== undefined &&
      this.HouseDidPlumbingElectricityWork !== null &&
      (this.HouseDidPlumbingElectricityWork as any) !== ''
    ) {
      const val = String(this.HouseDidPlumbingElectricityWork).trim().toLowerCase();
      if (val === '1' || val === 'true' || val === 'sim') {
        this.HouseDidPlumbingElectricityWork = '1';
      } else if (val === '0' || val === 'false' || val === 'não' || val === 'nao') {
        this.HouseDidPlumbingElectricityWork = '0';
      }
    }
  }
  ReceiveAlerts = 0;
  Newsletter = 0;
  GestaoEmailWhatsAp = 0;
  AceitoTransferenciaSeguro = 0;
  TransferenciaSeguro: string = '';
  ApoliceAnterior: string = '';
  NomeCartaoAdvanceCare: string = '';
  NomeCartaoMedis: string = '';
  NomeCartaoFutureHealthCare: string = '';
  SendSMS = 0;
  SendSMSDays = 0;
  SendEmail = 0;
  SendEmailDays = 0;
  safesimulationsFilesClass: FilesClass[] = [];
  RiskLocations: any[] = [];
  TitleForm: string = '';
  Modalidade: string = '';
  Versao: string = '';

  // Bicicleta e Trotinete / Equipamentos
  Brand?: string = '';
  Model?: string = '';
  Version?: string = '';
  FabricationDate?: any = null;
  Lotacao?: number | null = 1;
  SerialNumber?: string = '';

  //VIDA PLENA

  ITP: boolean = false;
  PercentagemITP: string = ''; // PercentagemITP60 //  PercentagemITP65 // Nenhum
  ITPAC: boolean = false;
  ListaEspera: boolean = false;
  SubsidioFuneral: boolean = false;
  SubsidioDiarioHospAC: boolean = false;
  ValorDiarioHospAC: number | null = null;
  MorteAcidenteCirculacao: boolean = false;
  FilhosMenoresCargo: boolean = false;
  DoencasGraves: boolean = false;
  DescBoaSaude1PSeg: boolean = false;
  DescBoaSaude2PSeg: boolean = false;
  duasPessoasSeguras: boolean = false;
  MorteAcidente: boolean = false;

  DataInicoContrato: any = dayjs.utc().add(1, 'day').startOf('day');
  DtNasc1PSeg: any = null;
  Name1: string = '';
  DtNasc2PSeg: any = null;
  Name2: string = '';
  ContactName: string = '';
  Spread?: number | null = null;
  PrazoAnos?: number | null = null;
  PrazoProjeccao?: number | null = null;
  DebitoConta?: number | null = null;
  Fraccionamento: string = '';
  ActualizacaoCapitais: number | null = null;
  ITP60: boolean = false;
  IPOrigem: string = '';
  Morte: boolean = false;

  FilhosMenores: boolean = false;
  InvalidezAbsoluta?: boolean = false;
  obterResultadosSimulacaoRVHObjJsonResultClass: ObterResultadosSimulacaoRVHObjJsonResultClass | null = null;
  robotclass: Robotclass | null = null;
  // tslint:disable-next-line:variable-name
  op_tipointermediacao: string = '';
  // tslint:disable-next-line:variable-name
  op_Valor: number | null = null;
  Valorcomissoes: number | null = null;
  idProductsTypesProposals: number | null = null;
  ShowNIB: boolean = false;
  NIB: string = '';
  OpenComponent: string = '';
  OpenComponentCotacoes: string = '';
  OpenproposalsComponent: string = '';
  OpenpurchaseComponent: string = '';
  OpenInsuranceClaimsComponent: string = '';
  showPurchaseQuestionnaire: boolean = false; // Controls which view is shown on Purchase tab: false = proposals, true = questionnaire
  idCommonbreeds?: number | null = null;
  commonbreedsDescription: string = '';
  idCommonbreedsType?: number | null = null;
  commonbreedsTypeDescription: string = '';
  idCommonGenre?: number | null = null;
  NomeAnimal: string = '';
  Dangerous: number | null = null;
  Sterilized: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
  FooterText1: string = '';
  FooterText2: string = '';
  productsProposalsTemplateClass: ProductsProposalsTemplateClass[] = [];
  productsProposalsClass: ProductsProposalsClass[] = [];
  DescErro: string = '';
  purchased: boolean = false;
  disabledNextButtonQuiz: boolean = false;
  disabledNextButton: boolean = false;
  disabledComeBackButton: boolean = false;
  disabledpurchasedButton: boolean = false;
  SkipQuiz: boolean = false;
  /** Flag global: verdadeiro enquanto os preços das propostas estão a ser calculados.
   * Quando true, a grelha de propostas fica oculta para evitar que o utilizador
   * veja os preços a aparecer um a um em ligações lentas. */
  isLoadingProposals: boolean = false;
  JsonSummary?: string;
  AreaOrigin?: string;

  /**
   * TransactionType explícito definido pela origem do componente:
   * - 'App Cliente'   → fluxo do simulador (productstypesitems)
   * - 'App Mediador'  → questionários do mediador (messagecentercotacao)
   * Se não definido, a API calcula a partir do AreaOrigin (comportamento legacy).
   */
  RequestedTransactionType?: string;

  // Embarcações
  idCommonVesselsHullMaterial: number | null = null;
  CommonVesselsHullMaterialDescription: string = '';
  idCommonVesselsHullMaterialLibertyCode: string = '';

  idCommonVesselsNavigationZone: number | null = null;
  idCommonVesselsNavigationZoneLibertyCode: string = '';

  idCommonVesselsTonnage: number | null = null;
  CommonVesselsTonnageDescription: string = '';
  idCommonVesselsTonnageLibertyCode: string = '';

  idCommonVesselsType: number | null = null;
  CommonVesselsTypeDescription: string | '' = '';

  idCommonVesselsTypeLibertyCode: string = '';

  VesselsTerceiros: boolean = false;
  VesselsTodosRiscos: boolean = false;
  VesselsCapital: string = '';
  VesselsLotacao: number | null = null;
  VesselsPotencia: number | null = null;
  VesselsAnoConstrucao: number | null = null;

  VesselsidCommonVesselsDamage: number | null = null;
  VesselsidCommonVesselsDamageCode: string = '';

  VesselsObrasReconstrucao: boolean = false;
  VesselsObrasReconstrucaoAno: string | number = '';
  VesselsPraticaSki: boolean = false;
  VesselsLibertyParticipaRegatas: number | null = null;

  // VesselsResponsabilidadeCivilTexto: string = '';
  VesselsDanosEmbarcacaoTexto: string = '';
  VesselsDanosEmbarcacaoCode: string = '';

  // VesselsRouboEmbarcacaoTexto: string = '';
  VesselsRouboEmbarcacao: boolean = false;

  VesselsGastosSalvamentoTexto: string = '';
  VesselsGastosSalvamento: boolean = false;

  // VesselsAssistenciaEmbarcacaoTexto: string = '';
  VesselsAssistenciaEmbarcacao: boolean = false;

  // VesselsAssidentesPessoaisTexto: string = '';
  VesselsidCommonVesselsPersonalAccidents: number | null = null;
  VesselsAcidentesPessoais: boolean = false;
  VesselsAcidentesPessoaisCode: string = '';

  VesselsGarantiasCapitaisTexto: string = '';

  Name: string = '';
  NIF: string = '';
  Email: string = '';
  CCNumber: string = '';
  CCDateValidate: any = null;
  Birthdate: any = null;
  idSexTypes: number | null = null;
  Sexo: string = '';
  Contact: string = '';
  idMaritalStatus: number | null = null;
  Country: string = '';
  Profession: string = '';
  CAE: string = '';
  PlaceOfBirth: string = '';
  Nationality: string = '';
  Drivinglicense: string = '';
  DrivinglicenseDate: any = null;
  DrivinglicenseExpirationDate: any = null;
  Employer: string = '';
  PEPq1: boolean = false;
  PEPq1Text: string = '';
  PEPq2: boolean = false;
  PEPq2Text: string = '';
  PEPq3: boolean = false;
  PEPq3Text: string = '';
  PetBirthdate: any = null;
  FATCAq1: boolean = false;
  FATCAq2: boolean = false;
  FATCAq3: boolean = false;
  SlideValue: number | null = null;
  PeriodicidadeAnual: boolean = false;
  PeriodicidadeSemestral: boolean = false;
  PeriodicidadeMensal: boolean = false;
  PeriodicidadeLivreUnico: boolean = false;
  AtualizacaoAnual: boolean = false;
  Premio: number | null = null;
  IndexacaoAnual: number | null = null;
  CapitalSeguro: number | null = null;
  SignatureDeclaracoes: string = '';
  SignatureDadosPessoais: string = '';

  AutorizacaoDebitoNome: string = '';
  AutorizacaoDebitoMorada: string = '';
  AutorizacaoDebitoCodigoPostal: string = '';
  AutorizacaoDebitoCodigoRegion: string = '';
  AutorizacaoDebitoPais: string = '';
  AutorizacaoDebitoIBAN: string = '';
  AutorizacaoDebitoBICSWIFT: string = '';
  AutorizacaoDebitoSeguradora: string = '';
  AutorizacaoDebitoData: any = null;
  AutorizacaoDebitoSignature: string = '';

  BeneficiariosTomadorSeguroNome: string = '';
  BeneficiariosOutros: boolean = false;
  BeneficiariosVidaNome: string = '';
  BeneficiariosVidParentescoComTomador: string = '';
  BeneficiariosVidaDataNascimento: string = '';
  BeneficiariosVidaMorada: string = '';
  BeneficiariosVidaCodPostal: string = '';
  BeneficiariosVidaRegiao: number | null = null;
  BeneficiariosVidaNIdentificacaoPassaporte: string = '';
  BeneficiariosVidaNIF: string = '';

  BeneficiariosMorteRepartidoPartesIguais: boolean = false;

  BeneficiariosMorteNome1: string = '';
  BeneficiariosMortePercent1: number | null = null;
  BeneficiariosMorteParentescoComTomador1: number | null = null;
  BeneficiariosMorteDataNascimento1: string = '';
  BeneficiariosMorteMorada1: number | null = null;
  BeneficiariosMorteCodPostal1: number | null = null;
  BeneficiariosMorteRegiao1: number | null = null;
  BeneficiariosMorteNIdentificacaoPassaporte1: string = '';
  BeneficiariosMorteNIF1: string = '';

  BeneficiariosMorteNome2: string = '';
  BeneficiariosMortePercent2: number | null = null;
  BeneficiariosMorteParentescoComTomador2: number | null = null;
  BeneficiariosMorteDataNascimento2: string = '';
  BeneficiariosMorteMorada2: number | null = null;
  BeneficiariosMorteCodPostal2: number | null = null;
  BeneficiariosMorteRegiao2: number | null = null;
  BeneficiariosMorteNIdentificacaoPassaporte2: string = '';
  BeneficiariosMorteNIF2: string = '';

  BeneficiariosMorteNome3: string = '';
  BeneficiariosMortePercent3: number | null = null;
  BeneficiariosMorteParentescoComTomador3: number | null = null;
  BeneficiariosMorteDataNascimento3: string = '';
  BeneficiariosMorteMorada3: number | null = null;
  BeneficiariosMorteCodPostal3: number | null = null;
  BeneficiariosMorteRegiao3: number | null = null;
  BeneficiariosMorteNIdentificacaoPassaporte3: string = '';
  BeneficiariosMorteNIF3: string = '';

  BeneficiariosMorteNome4: string = '';
  BeneficiariosMortePercent4: number | null = null;
  BeneficiariosMorteParentescoComTomador4: number | null = null;
  BeneficiariosMorteDataNascimento4: string = '';
  BeneficiariosMorteMorada4: number | null = null;
  BeneficiariosMorteCodPostal4: number | null = null;
  BeneficiariosMorteRegiao4: number | null = null;
  BeneficiariosMorteNIdentificacaoPassaporte4: string = '';
  BeneficiariosMorteNIF4: string = '';

  BeneficiariosMorteNome5: string = '';
  BeneficiariosMortePercent5: number | null = null;
  BeneficiariosMorteParentescoComTomador5: number | null = null;
  BeneficiariosMorteDataNascimento5: string = '';
  BeneficiariosMorteMorada5: number | null = null;
  BeneficiariosMorteCodPostal5: number | null = null;
  BeneficiariosMorteRegiao5: number | null = null;
  BeneficiariosMorteNIdentificacaoPassaporte5: string = '';
  BeneficiariosMorteNIF5: string = '';

  BeneficiariosMorteMenorNomeTutor1: string = '';
  files: number | null = null;
  BikeNewprice: number | null = null;
  Bikemotor: boolean = false;
  BikeVelocidadeMaxima: number | null = null;
  BikePesoBruto: number | null = null;
  BikePotenciaMotor: number | null = null;
  Recalculate: boolean = false;

  AutoCampaign: string = ''; //In LOV  MassAutoQuoteLOV
  AutoModality: string = ''; //In LOV  MassAutoQuoteLOV
  // Entidade
  FiscalNumber: string = '';
  AutoHolderType: string = ''; //In LOV  MassAutoQuoteLOV
  AutoGender: string = ''; //In LOV  MassAutoQuoteLOV
  //Veiculo
  idCommonAutoVehicleType: number | null = null;
  idCommonAutoVehicleUsage: number | null = null;
  idCommonAutoVehicleSelection: number | null = null;
  idCommonAutoFuel: number | null = null;
  idCommonAutoBrand: number | null = null;
  idCommonAutoBrandModel: number | null = null;
  idCommonAutoBrandModelVersion: number | null = null;
  idCommonAutoVehicleKeepPriceAsNew: number | null = null;

  Autoregistration: number | null = null;
  AutoNewVehicle: number | null = null;
  AutoVehiclePlate: string = '';
  AutoVehicleSelectionType: string = '';
  AutoVehicleTylacode: number | null = null;
  AutoVehicleBrand: string = '';
  AutoVehicleModel: string = '';
  AutoVehicleVersion: string = '';
  AutoVehicleType: string = '';
  AutoVehicleUsage: string = '';
  AutoVehiclePlateDate: any = null;
  AutoVehiclePlateYear: number | null = null;
  AutoVehiclePlateMonth: number | null = null;
  AutoVehiclePriceAsNew: number | null = null;
  AutoVehiclePriceNewValueType: string = ''; //In LOV  MassAutoQuoteLOV
  AutoVehicleExtras: number | null = null;
  AutoVehicleWeight: number | null = null;
  AutoVehicleCV: number | null = null;
  AutoVehicleCC: number | null = null;
  AutoVehicleSeats: number | null = null;
  AutoVehicleFuelClass: string = '';
  AutoUseTrailer: boolean = false;
  AutoTrailer1Weight: number | null = null;
  AutoTrailer2Weight: number | null = null;
  AutoTrailer3Weight: number | null = null;
  AutoCheckALLQuiz: number | null = null;
  AutoIsUsedInSportCompetitions: number | null = null;
  AutoCirculatesInAirports: number | null = null;
  AutoTransportsHazardousMaterials: number | null = null;
  AutoMakesFastDeliveries: number | null = null;
  AutoMakesInternationalDeliveries: number | null = null;
  AutoTransportsPersonsInCargoBox: number | null = null;
  AutoIsTransformedVehicle: number | null = null;
  AutoIsPaidTransportAndNotTaxi: number | null = null;
  // Coverages CivilLiability
  idCommonAutoLiability: number | null = null;
  AutoCivilLiabilityIsSelected: boolean = false;
  AutoCivilLiabilityOption: string[] = []; //In LOV  MassAutoQuoteLOV
  AutoCivilLiabilityOptionString: string = '';
  AutoLegalAdviceIsSelected: boolean = false;
  AutoidCommonAutoBrokenGlass: number | null = null;
  AutoBrokenGlassIsSelectedAux: number | null = null;
  AutoBrokenGlassIsSelected: boolean = false;
  AutoBrokenGlassOption: string = '';
  AutoBrokenGlassAgreedIsSelected: boolean = false;
  AutoBrokenGlassAgreedOption: string = '';
  AutoCrashesIsSelected: boolean = false;
  AutoCrashesDeductible: string = '';
  AutoFireIsSelected: boolean = false;
  AutoFireDeductible: string = '';
  AutoStolenIsSelected: boolean = false;
  AutoTotalLossIsSelected: boolean = false;
  AutoEnvironmentalIsSelected: boolean = false;
  AutoEnvironmentalDeductible: string = '';
  AutoMaliciousDamageIsSelected: boolean = false;
  AutoMaliciousDamageDeductible: string = '';
  AutoAntiTheftDeviceIsSelected: boolean = false;
  AutoPassengersIsSelected: boolean = false;
  AutoPassengersOption: string = '';
  AutoDriverOnlyIsSelected: boolean = false;
  AutoDriverOnlyOption: string = '';
  AutoTravelAssistanceIsSelected: boolean = false;
  AutoTravelAssistanceExtendedIsSelected: boolean = false;
  AutoTravelAssistanceLightIsSelected: boolean = false;
  AutoPersonalAssistanceIsSelected: boolean = false;
  AutoLuggageIsSelected: boolean = false;
  AutoCarReplacementIsSelected: boolean = false;
  AutoCarReplacementOption: string = '';
  AutoCarReplacementMaintenanceIsSelected: boolean = false;
  AutoCarReplacementMaintenanceOption: string = '';
  AutoBonusMalus: number | null = null;
  AutoDayMaturity: string = '';
  AutoMonthMaturity: string = '';
  AutoPaymentSystem: string = '';
  AutoPaymentFrequency: string = '';
  JSONProposal: string = '';
  JSONProductsTypesPurchaseConfigStepperComponentClass: string = '';
  configStepperClass: ConfigStepperClass[] = [];
  FieldPositions: ConfigStepperComponentClass[] = [];
  productsTypesPurchaseConfigPDFClass: FilesClass | null = null;
  Order: number | null = null;
  productsProposalsClassPurchaseClass: ProductsProposalsClass | null = null;
  DadosFinalizarCompraValid: boolean | null = false;
  OrigemDoClick: string = '';
  Comments: string = '';
  idMessageCenterStatus?: number | null = null;
  ReminderDate?: any = null;
  FracionamentoSeleccaoMultipla: string[] = [];
  fracionamentoSeleccaoMultiplaString: string = '';
  FormaPagamentoSeleccaoMultipla: string[] = [];
  TvdeOutrasMatriculas: string = '';
  FormaPagamentoSeleccaoMultiplaString: string = '';
  plano: string[] = [];
  CapitalBuilding: number | null = null;
  FillingCapital: number | null = null;
  HouseConstructionyear: number | null = null;
  HouseDidPlumbingElectricityWork: any = null;
  HouseYearReconstruction: number | null = null;
  HouseArea: number | null = null;
  HouseBedrooms: number | null = null;
  HouseWC: number | null = null;
  HouseRiskLocation: string = '';
  HouseCAE: string = '';
  idCommonMeansOfSecurity: number | null = null;
  idCommonMeansOfSecurityOther: boolean = false;
  CommonMeansOfSecurityDescription: string = '';
  CommonMeansOfSecurityOther: string = '';
  idTypeOfConstruction: number | null = null;
  idTypeOfConstructionRequestOther: boolean = false;
  TypeOfConstructionDescription: string = '';
  TypeOfConstructionOther: string = '';

  idProductsTypesTypeOfHousing: number | null = null;
  idProductsTypesTypeOfHousingOther: boolean = false;
  ProductsTypesTypeOfHousingDescription: string = '';
  ProductsTypesTypeOfHousingOther: string = '';

  idCommonMeansAgainstFire: number | null = null;
  idCommonMeansAgainstFireOther: boolean = false;
  CommonMeansAgainstFireDescription: string = '';
  CommonMeansAgainstFireOther: string = '';

  CondominiumNIF: string = '';

  NumberOfBuildings: number | null = null;
  TotalFractions: number | null = null;
  TotalCapital: number | null = null;
  CapitalCommonShares: number | null = null;
  NumberOfFractionsToHold: number | null = null;
  CapitalToInsure: number | null = null;
  TotalFloors: number | null = null;
  NumberOfElevators: number | null = null;
  HousingOccupation: string = '';
  CommercialOccupation: string = '';

  Genre: string = '';
  BreedsType: string = '';
  EmailNotifyProduction: boolean = false;
  SendPurchaseToEmail: string = '';
  LastName: string = '';
  capturedScreen?: any;

  Weight: number | null = null;
  stepperDialogComponent = 'StepperpurchaseComponent';
  tomorrow: any = dayjs().add(1, 'day');
  today: any = dayjs();
  anoatual: number = dayjs().year();

  tipoContratacao: string = '';
  numeroParticipantes: number = 0;
  atividadesPeriodosConcatenados: string;

  idadesConcatenadas: string;
  numeroPessoas: number = 1;
  planoConcatenados: string;

  ArrivalDate: any | null = null;
  travelDuration: number = 0;
  numberOfAdults: number = 0;
  numberOfChildren: number = 0;
  selectedCountries: string = '';

  Atributo1: string = '';
  Atributo2: string = '';
  Atributo3: string = '';
  Atributo4: string = '';
  Atributo5: string = '';
  Atributo6: string = '';
  Atributo7: string = '';
  Atributo8: string = '';
  Atributo9: string = '';
  Atributo10: string = '';

  // Getters e Setters para Condutor habitual (mapeados a atributos genéricos para evitar alterações na BD)
  get DriverNif(): string {
    return this.Atributo1 === '0' ? '' : this.Atributo1 || '';
  }
  set DriverNif(value: string) {
    this.Atributo1 = value;
  }

  get DriverName(): string {
    return this.Atributo2;
  }
  set DriverName(value: string) {
    this.Atributo2 = value;
  }

  get DriverAddress(): string {
    return this.Atributo3;
  }
  set DriverAddress(value: string) {
    this.Atributo3 = value;
  }

  // Cache para evitar criar novos objectos dayjs a cada leitura (previne loop infinito de change detection)
  private _driverDOBCache: any = null;
  private _driverDOBSource: string = '';

  get DriverDateOfBirth(): any {
    if (!this.Atributo4) return null;
    // Devolver cache se a fonte não mudou
    if (this._driverDOBSource === this.Atributo4 && this._driverDOBCache !== null) {
      return this._driverDOBCache;
    }
    let d = dayjs(this.Atributo4, 'YYYY-MM-DD', true);
    if (!d.isValid()) {
      d = dayjs(this.Atributo4, 'DD-MM-YYYY', true);
    }
    if (!d.isValid()) {
      d = dayjs(this.Atributo4, 'DDMMYYYY', true);
    }
    if (!d.isValid()) {
      d = dayjs(this.Atributo4, 'DD/MM/YYYY', true);
    }
    this._driverDOBSource = this.Atributo4;
    this._driverDOBCache = d.isValid() ? d : this.Atributo4;
    return this._driverDOBCache;
  }
  set DriverDateOfBirth(value: any) {
    // Invalidar cache
    this._driverDOBCache = null;
    this._driverDOBSource = '';
    if (!value) {
      this.Atributo4 = '';
      return;
    }
    if (dayjs.isDayjs(value)) {
      this.Atributo4 = value.isValid() ? value.format('YYYY-MM-DD') : '';
      return;
    }
    if (value instanceof Date) {
      const d = dayjs(value);
      this.Atributo4 = d.isValid() ? d.format('YYYY-MM-DD') : '';
      return;
    }
    if (typeof value === 'string') {
      let d = dayjs(value, 'YYYY-MM-DD', true);
      if (!d.isValid()) {
        d = dayjs(value, 'DD-MM-YYYY', true);
      }
      if (!d.isValid()) {
        d = dayjs(value, 'DDMMYYYY', true);
      }
      if (!d.isValid()) {
        d = dayjs(value, 'DD/MM/YYYY', true);
      }

      if (d.isValid()) {
        this.Atributo4 = d.format('YYYY-MM-DD');
      } else {
        this.Atributo4 = value;
      }
      return;
    }
    const dGen = dayjs(value);
    this.Atributo4 = dGen.isValid() ? dGen.format('YYYY-MM-DD') : value;
  }

  get TvdeEmpresaNif(): string {
    return this.Atributo5;
  }
  set TvdeEmpresaNif(value: string) {
    this.Atributo5 = value;
  }

  get TvdeProprietarioNif(): string {
    return this.Atributo6;
  }
  set TvdeProprietarioNif(value: string) {
    this.Atributo6 = value;
  }

  get TvdeEmpresaNome(): string {
    return this.Atributo7;
  }
  set TvdeEmpresaNome(value: string) {
    this.Atributo7 = value;
  }

  get TvdeEmpresaCodPostal(): string {
    return this.Atributo8;
  }
  set TvdeEmpresaCodPostal(value: string) {
    this.Atributo8 = value;
  }

  get DriverPostalCode(): string {
    return this.Atributo9;
  }
  set DriverPostalCode(value: string) {
    this.Atributo9 = value;
  }

  get DriverRegion(): string {
    return this.Atributo10;
  }
  set DriverRegion(value: string) {
    this.Atributo10 = value;
  }

  DriverDrivingLicense: string = '';
  DriverDrivingLicenseDate: any = null;

  // --- VIAGEM / INTERMUNDIAL ---
  travelAmbit: string = ''; // ex-Âmbito selecionado
  furthestCountry: string = ''; // país mais distante
  Ambito: string = ''; // usado no [(ngModel)]="...Ambito"

  // intermundialPolicyMetaById?: { [policyId: number]: IntermundialPolicyMeta };
  intermundialProposals?: IntermundialProposal[];

  intermundialpolicyDetails: Map<number, PolicyDetails> = new Map<number, PolicyDetails>();
  intermundialcoverageUnion: Array<{ key: string; label: string }> = [];
  intermundiallastTypeIdFromService: number | null = null;
  intermundialglobalMaxDurationDays: number | null = null;

  // Intermundial Purchase Data
  IntermundialPax: number = 1;
  IntermundialStartDate: any | null = null;
  IntermundialEndDate: any | null = null;
  IntermundialFurthestCountry: string = '';
  intermundialSelectedProposal: IntermundialProposal | null = null;
}

export class IntermundialProposal {
  policyId: number;
  policyNumber?: string | null;
  name: string;
  product: ProductClass | null;
  bullets: string[];

  addonsDefinitions: PriceListParamClass[];

  ambit: {
    key: string;
    valueId: number | null;
    value: any;
  } | null;

  duration: {
    days: number;
    valueId: number | null;
    value: any;
  } | null;

  selectedAddons: Array<{
    paramId: number;
    valueId: number;
    value: any;
  }>;

  quotePreset: any;
  pricing: IntermundialPricingResponse | null;
  retailPriceAmount: number | null;
  currency: string | null;

  error?: string;
  loading?: boolean;
  order?: number;
  productName?: string | null;
  policy?: IntermundialPolicyInfo | null;
}

// Intermundial  apenas o que realmente usamos aqui
interface IntermundialPolicyInfo {
  policyNumber?: string | null;
}

export class BeneficiariesClass {
  idSafeSimulations = null;
  VidaNome: string = '';
}

// Mantém as tuas versões slim já existentes
export interface IntermundialPricingSlim {
  netPremiumAmount?: number | null;
  netRetailPrice?: number | null;
  paxRetailPrice?: number | null;
  retailPriceAmount?: number | null;

  currency?: string;
  priceListId?: number | null;
  policyId?: number | null;
  basePricesIdDyn?: number | null;
  isFlatRate?: boolean;
  isPaymentLetter?: boolean;

  selectedParams?: Array<{
    paramIndex: number;
    idDyn: number;
    name?: string;
    minRange?: number | null;
    maxRange?: number | null;
  }>;

  coverageExtensions?: any[];

  policyNumber?: string | null;
  productIdDyn?: number | null;
  productName?: string | null;

  raw?: any; // ? guardas o payload, mas sem raw encadeado
}

export interface IntermundialPolicyMeta {
  policyId?: number | null;
  policyNumber?: string | null;
  policyBranch?: string | null;

  productIdDyn?: number | null;
  productName?: string | null;
  logoUrl?: string | null;
  backgroundUrl?: string | null;

  // Bullets completos (plan, info, description)
  bullets?: Array<{ plan: number | null; info: string; description?: string }>;

  // Params disponíveis (Destino, Duração, )
  params?: Array<{
    idDyn?: number;
    name?: string;
    paramType?: string;
    plan?: number | null;
    values?: Array<{
      idDyn?: number;
      name?: string;
      minRange?: number | null;
      maxRange?: number | null;
      countryIsoList?: string[]; // opcional
    }>;
  }>;

  priceListId?: number | null;
  priceListPeriods?: Array<{ idDyn?: number; startDate?: string; endDate?: string }>;
  currencySymbol?: string | null;
  currencyName?: string | null;
  clientCommissionRate?: number | null;
  brokerageCommissionRate?: number | null;

  conditions?: Array<{ entity?: string; field?: string; condition?: string; value?: any; isBoolean?: boolean }>;

  raw?: any; // payload do getPolicy
}

export class ProductsProposalsTemplateClass {
  idProductsTypesTemplate: number | null = null;
  Visible: boolean = true;
  idProductsTypes: number | null = null;
  Field: string = '';
  FieldType: string = '';
  FieldExpanded: string = '';
  idCommonFieldType: number | null = null;
  LinhaInativo: boolean = false;

  linesTemplate: number | null = null;
  TextAlignTemplate: string = '';
  FontSizeTemplate: number | null = null;
  FontWeightTemplate: string = '';
  TextColorTemplate: string = '';

  lines: number | null = null;
  TextAlign: string = '';
  FontSize: number | null = null;
  FontWeight: string = '';

  DateStart: Date = new Date();
  DateEnd: Date | null = null;
  Background: string = '';
  TextColor: string = '';

  Tooltip: string = '';
  Order: number | null = null;
  UUIDLastChange: string = '';
  UUID: string = '';
  ProductsName: string = '';
  ProductsBackgroundColor: string = '';
  ProductsDescription: string = '';
  ProductsTextColor: string = '';
  ProductsTypesName: string = '';
  ProductsTypesBackgroundColor: string = '';
  ProductsTypesDescription: string = '';
  ProductsTypesTextColor: string = '';

  ItemTemplatemaxwidth: number | null = null;
  ItemTemplateminwidth: number | null = null;

  ItemTemplatewidth: number | null = null;
  Proposalsmaxwidth: number | null = null;
  Proposalsminwidth: number | null = null;
  Proposalswidth: number | null = null;

  // para eliminar
  isVlComissoes: boolean = false;
  isCapital: boolean = false;
  isPaymentsTypes: boolean = false;
  isConditions: boolean = false;
  isMorte: boolean = false;
  isMorteAcidente: boolean = false;
  isFilhosMenores: boolean = false;
  isInvalidezAbsoluta: boolean = false;
  isITP60: boolean = false;
  isSlideValue: boolean = false;
  isFile: boolean = false;
  isResponsabilidadeCivil: boolean = false;
  isDanosEmbarcacao: boolean = false;
  isRouboEmbarcacao: boolean = false;
  isGastosSalvamento: boolean = false;
  isAssistenciaEmbarcacao: boolean = false;
  isAcidentesPessoais: boolean = false;
  isGarantiasCapitais: boolean = false;
  isPlanoPagamento: boolean = false;
  isPaymentsSplit: boolean = false;
  ReadOnly: boolean = false;
  DefaultFieldFilter: string = '';
  isFilter: boolean = false;
  BloquearColuna: boolean = false;
  productsProposalsDetailsClass: ProductsProposalsDetailsClass[] = []; // este campo é utilizado para configurar o layout dos PDFs
  productsProposalsDetailsFilesClass: FilesClass[] = [];
}

export class ProductsProposalsCompareClass {
  compare: boolean = false;
  ListprodusctsClass: ListprodusctsClass[] = [];
}

export class ListprodusctsClass {
  idProductsTypesProposals: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  idCompanie: number | null = null;
  CompaniesIcon: Image | null = null;
  Description: string = '';
  PriceDescription: string = '';
}

export class ProductsProposalsClass {
  [x: string]: any;
  Favorite: boolean = false;
  loadingProgress: boolean = false;
  indisponivel: boolean = false;
  precoindisponivel: boolean = false;
  idProductsTypesProposals: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  idCommonNIFType: number | null = null;
  idCompanie: number | null = null;
  idPaymentsSplit: number | null = null;
  paymentsSlipsName: string = '';
  idPaymentsTypes: number | null = null;
  paymentsTypesName: string = '';

  idCommonbreeds: number | null = null;
  idCommonbreedsType: number | null = null;
  idCommonGenre: number | null = null;
  Description: string = '';
  CompaniesIcon: Image | null = null;
  CompaniesName: string = '';
  VlComissoes1: string = '';
  VlComissoes2: string = '';
  PackGroupNumber: number | null = null;
  PriceDescription: string = '';
  idProductsTypesProposalsFilter: number | null = null;
  idProductsTypesProposalsFilter0: number | null = null;
  idProductsTypesProposalsFilter1: number | null = null;
  idProductsTypesProposalsFilter2: number | null = null;
  idProductsTypesProposalsFilter3: number | null = null;
  idProductsTypesProposalsFilter4: number | null = null;
  idProductsTypesProposalsFilter5: number | null = null;
  idProductsTypesProposalsFilter6: number | null = null;
  idProductsTypesProposalsFilter7: number | null = null;
  idProductsTypesProposalsFilter8: number | null = null;
  idProductsTypesProposalsFilter9: number | null = null;
  idProductsTypesProposalsFilter10: number | null = null;
  idProductsTypesProposalsFilter11: number | null = null;
  idProductsTypesProposalsFilter12: number | null = null;
  idProductsTypesProposalsFilter13: number | null = null;
  idProductsTypesProposalsFilter14: number | null = null;
  idProductsTypesProposalsFilter15: number | null = null;
  idProductsTypesProposalsFilter16: number | null = null;
  idProductsTypesProposalsFilter17: number | null = null;
  idProductsTypesProposalsFilter18: number | null = null;
  idProductsTypesProposalsFilter19: number | null = null;
  idProductsTypesProposalsFilter20: number | null = null;

  productsProposalsPaymentsSplitClass: ProductsProposalsPaymentsSplitClass[] = []; // remover
  productsTypesProposalsPaymentsFilter0: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter1: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter2: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter3: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter4: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter5: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter6: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter7: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter8: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter9: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter10: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter11: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter12: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter13: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter14: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter15: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter16: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter17: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter18: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter19: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilter20: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsFilterALL: ProductsTypesProposalsPaymentsFilter[] = [];
  productsTypesProposalsPaymentsSplitPricesALL: ProductsProposalsPaymentsSplitClass[] = [];
  Price: number | null = null;
  suggest: boolean = false;
  Order: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  PropostaInativo: boolean = false;
  DiscountPercent: number | null = null;
  FooterLine1: string = '';
  FooterLine2: string = '';
  Tooltip: string = '';
  isWebService: boolean = false;
  WebService: string = '';
  isRobot: boolean = false;
  Robot: string = '';
  selected: boolean = false;
  lines: number | null = null;
  isSlideValue: boolean = false;
  MinSlideValue: number | null = null;
  MaxSlideValue: number | null = null;
  StepValue: number | null = null;
  CodigoMediador: number | null = null;
  OpenpurchaseComponent: string = '';
  ReplaceCoverage: boolean = false;
  UUID: string = '';
  UUIDLastChange?: any;
  productsProposalsDetailsClass: ProductsProposalsDetailsClass[] = [];

  Observations: string = '';
  NotificationPurchaseConfig: string | null = null;
  Formula: string = '';
  SlideValue: number | null = null;

  ColSpace: boolean = false;
  // productsProposalsPaymentsSplitClass: ProductsProposalsPaymentsSplitClass[];

  //VIDA Havbitação
  InvalidezAbsoluta?: boolean = false;
  Utilizador: string = '';
  Password: string = '';
  Modalidade: string = '';
  Versao: string = '';
  DataInicoContrato: Date | null = null;
  DtNasc1PSeg: Date | null = null;
  DtNasc2PSeg: Date | null = null;
  Capital: number | null = null;
  Spread: number | null = null;
  PrazoAnos: number | null = null;
  PrazoProjeccao: number | null = null;
  DebitoConta: number | null = null;
  Fraccionamento: string = '';
  ActualizacaoCapitais: number | null = null;
  ITP60: boolean = false;
  Morte: boolean = false;
  MorteAcidente: boolean = false;
  FilhosMenores: boolean = false;

  ITP: boolean = false;
  PercentagemITP: string = ''; // PercentagemITP60 //  PercentagemITP65 // Nenhum
  ITPAC: boolean = false;
  ListaEspera: boolean = false;
  SubsidioFuneral: boolean = false;
  SubsidioDiarioHospAC: boolean = false;
  ValorDiarioHospAC: number | null = null;
  MorteAcidenteCirculacao: boolean = false;
  FilhosMenoresCargo: boolean = false;
  DoencasGraves: boolean = false;
  DescBoaSaude1PSeg: boolean = false;
  DescBoaSaude2PSeg: boolean = false;
  duasPessoasSeguras: boolean = false;

  get DriverNif(): string {
    return this.Atributo1 === '0' ? '' : this.Atributo1 || '';
  }
  set DriverNif(value: string) {
    this.Atributo1 = value;
  }

  get DriverName(): string {
    return this.Atributo2;
  }
  set DriverName(value: string) {
    this.Atributo2 = value;
  }

  get DriverAddress(): string {
    return this.Atributo3;
  }
  set DriverAddress(value: string) {
    this.Atributo3 = value;
  }

  DriverDateOfBirth: Date | null = null;
  DrivingLicenceDate: Date | null = null;
  DriverZipCode: string = '';
  DriverDrivingLicense: string = '';
  DriverDrivingLicenseDate: any = null;

  // Dados Webservice liberty Auto
  AutoCampaign: string = ''; //In LOV  MassAutoQuoteLOV
  AutoModality: string = ''; //In LOV  MassAutoQuoteLOV
  // Entidade
  FiscalNumber: string = '';
  AutoName: string = '';
  AutoHolderType: string = ''; //In LOV  MassAutoQuoteLOV
  AutoGender: string = ''; //In LOV  MassAutoQuoteLOV

  //Veiculo

  Autoregistration: number | null = null;
  AutoNewVehicle: number | null = null;
  AutoVehiclePlate: string = '';
  AutoVehicleSelectionType: string = '';
  AutoVehicleTylacode: number | null = null;
  AutoVehicleBrand: string = '';
  AutoVehicleModel: string = '';
  AutoVehicleVersion: string = '';
  AutoVehicleType: string = '';
  AutoVehicleUsage: string = '';
  AutoVehiclePlateYear: number | null = null;
  AutoVehiclePlateMonth: number | null = null;
  AutoVehiclePriceAsNew: number | null = null;
  AutoVehiclePriceNewValueType: string = ''; //In LOV  MassAutoQuoteLOV
  AutoVehicleExtras: number | null = null;
  AutoVehicleWeight: number | null = null;
  AutoVehicleCV: number | null = null;
  AutoVehicleCC: number | null = null;
  AutoVehicleSeats: number | null = null;

  AutoVehicleFuelClass: string = '';
  AutoUseTrailer: boolean = false;
  AutoTrailer1Weight: number | null = null;
  AutoTrailer2Weight: number | null = null;
  AutoTrailer3Weight: number | null = null;

  //Questionary
  AutoIsUsedInSportCompetitions: number | null = null;
  AutoCirculatesInAirports: number | null = null;
  AutoTransportsHazardousMaterials: number | null = null;
  AutoMakesFastDeliveries: number | null = null;
  AutoMakesInternationalDeliveries: number | null = null;
  AutoTransportsPersonsInCargoBox: number | null = null;
  AutoIsTransformedVehicle: number | null = null;
  AutoIsPaidTransportAndNotTaxi: number | null = null;

  // Coverages CivilLiability
  AutoCivilLiabilityIsSelected: boolean = false;
  AutoCivilLiabilityOption: string[] = []; //In LOV  MassAutoQuoteLOV

  AutoLegalAdviceIsSelected: boolean = false;

  AutoBrokenGlassIsSelected: boolean = false;
  AutoBrokenGlassOption: string = ''; // ??

  AutoBrokenGlassAgreedIsSelected: boolean = false;
  AutoBrokenGlassAgreedOption: string = '';

  AutoCrashesIsSelected: boolean = false;
  AutoCrashesDeductible: string = '';
  AutoFireIsSelected: boolean = false;
  AutoFireDeductible: string = '';
  AutoStolenIsSelected: boolean = false;
  AutoTotalLossIsSelected: boolean = false;
  AutoEnvironmentalIsSelected: boolean = false;
  AutoEnvironmentalDeductible: string = '';
  AutoMaliciousDamageIsSelected: boolean = false;
  AutoMaliciousDamageDeductible: string = '';

  AutoAntiTheftDeviceIsSelected: boolean = false;

  AutoPassengersIsSelected: boolean = false;
  AutoPassengersOption: string = '';
  AutoDriverOnlyIsSelected: boolean = false;
  AutoDriverOnlyOption: string = '';

  AutoTravelAssistanceIsSelected: boolean = false;
  AutoTravelAssistanceExtendedIsSelected: boolean = false;
  AutoTravelAssistanceLightIsSelected: boolean = false;
  AutoPersonalAssistanceIsSelected: boolean = false;
  AutoLuggageIsSelected: boolean = false;
  AutoCarReplacementIsSelected: boolean = false;
  AutoCarReplacementOption: string = '';
  AutoCarReplacementMaintenanceIsSelected: boolean = false;
  AutoCarReplacementMaintenanceOption: string = '';
  AutoBonusMalus: number | null = null;

  //BrokenGlassAgreed

  AutoDayMaturity: string = '';
  AutoMonthMaturity: string = '';
  AutoPaymentSystem: string = '';
  AutoPaymentFrequency: string = '';

  AutoPolicyStartDate: Date | null = null;

  Readonly: boolean = false;
  AutoRefresh: boolean = false;

  // este campo serve apenas para o formulário de manutenção
  Name: string = '';

  PDFProposal: any;
  BloquearColuna: boolean = false;

  compare: boolean = false;
  Unavailable: boolean = false;
}

export class ProductsProposalsDetailsClass {
  idProductsTypesTemplate: number | null = null;
  idProductsTypes: number | null = null;
  Field: string = '';
  FieldType: string = '';
  MatchPhrase?: string;
  FileName: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  FontSize: number | null = null;
  FontWeight: string = '';
  Background?: string = '';
  TextColor?: string = '';
  TextAlign: string = '';
  isPaymentsTypes: number | null = null;
  isConditions: number | null = null;
  ReadOnly: boolean = false;
  isVlComissoes: boolean = false;
  isCapital: number | null = null;
  isMorte?: number | null = null;
  isMorteAcidente?: number | null = null;
  isFilhosMenores?: number | null = null;
  isInvalidezAbsoluta?: number | null = null;
  isITP60?: number | null = null;

  isTrueOrFalse?: number | null = null;
  isFormatNumber: boolean = false;
  isPaymentsSplit: boolean = false;
  isFile: boolean = false;
  Order: number | null = null;
  isURL: number | null = null;
  idProductsTypesProposalsDetails?: number | null = null;
  idProductsTypesProposals?: number | null = null;
  Value: string = '';
  ValueCheck: boolean = false;
  Tooltip: string = '';
  DetailsFontSize?: number | null = null;
  DetailsFontWeight?: string = '';
  DetailsBackground?: string = '';
  DetailsTextColor?: string = '';
  DetailsTextAlign: string = '';

  lines: number | null = null;
  isSlideValue: boolean = false;

  ProductsName: string = '';
  ProductsBackgroundColor: string = '';
  ProductsDescription: string = '';
  ProductsTextColor: string = '';

  ColSpan: number | null = null;
  Visible: boolean = false;

  UUID: string = '';
  UUIDLastChange?: any;

  ProductsTypesName: string = '';
  ProductsTypesBackgroundColor: string = '';
  ProductsTypesDescription: string = '';
  ProductsTypesTextColor: string = '';

  productsProposalsDetailsFilesClass: FilesClass[] = [];
  Inativo: boolean = false;

  DefaultFieldFilter: string = '';
  isFilter: boolean = false;
  productsProposalsDetailsClass: ProductsProposalsDetailsClass[] = [];

  OriginalFieldType?: string; // guarda o FieldType original (ex: "im_CRU_REPAT")
  FilterIndex?: number; // 0,1,2,... quando convertido para isFilterN
}

export class Image {
  type: string = '';
  data: number[] = [];
}

export class SafeSimulationsStatusTypes {
  idSafeSimulationsStatusTypes: number | null = null;
  Description: string = '';
  Background: string = '';
  TextColor: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: number | null = null;
  purchased: number | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class SafeSimulationsMessages {
  idSafeSimulationsMessage: number | null = null;
  idSafeSimulations: number | null = null;
  Subject: string = '';
  Text: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  idSafeSimulationsMessageOwner: number | null = null;
  fromidCommercial: number | null = null;
  toidCommercial: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  safeSimulationsMessagesFiles: SafeSimulationsMessagesFiles[] = [];
}

export class SafeSimulationsMessagesFiles {
  idSafeSimulationsMessagesFiles: number | null = null;
  idSafeSimulationsMessage: number | null = null;
  subjectfile: string = '';
  DocumentName: string = '';
  updated: Date | null = null;
  FilePath: string = '';
  type: string = '';
  size: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class ProductsTypesProposalsPaymentsFilter {
  idProductsTypesProposalsFilter: number | null = null;
  idProductsTypesProposals: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  Default: number | null = null;
  suggest: boolean = false;
  TypesClass: PaymentsTypesClass[] = [];
  SplitClass: PaymentsSplitClass[] = [];
  PaymentsSplitClass: ProductsProposalsPaymentsSplitClass[] = [];
  depth: number | null = null;
  Color: string = '';
  Disabled: boolean = false;
  childs: number | null = null;
  path: string = '';
  Order_Path: string = '';
  idProductsTypesProposalsFilterOwner: number | null = null;
  Inativo: boolean = false;
  policyId: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
  idProductsTypesProposalsPaymentsFilter: number;
  policyNumberExternal: string = '';
}

export class ProductsTypesProposalsProjectionTable {
  coluna1: string = '';
  coluna2: string = '';
  coluna3: string = '';
}

export class IntermundialSimulacaoClass {
  policyId: number | null = null;
  origin: string = 'INT';
  selectedCountries: string = '';
  travelDuration: number = 0;
  numberOfAdults: number = 1;
  numberOfChildren: number = 0;
}

export class IntermundialPricingResponse {
  retailPriceAmount: number | null = null;
  netPremiumAmount: number | null = null;
  paxRetailPrice: number | null = null;
  currency: string = '';
  priceListId: number | null = null;
  basePrices: { idDyn: number | null } | null = null;
  quotePresetList: any[] = [];
  raw: any;

  constructor(x: any = {}) {
    this.retailPriceAmount = x?.retailPriceAmount ?? null;
    this.netPremiumAmount = x?.netPremiumAmount ?? null;
    this.paxRetailPrice = x?.paxRetailPrice ?? null;
    this.currency = x?.currency ?? '';
    this.priceListId = x?.priceListId ?? null;
    this.basePrices = x?.basePrices ?? null;
    this.quotePresetList = Array.isArray(x?.quotePresetList) ? x.quotePresetList : [];
    this.raw = x;
  }
}

/** ======= Auxiliares de topo ======= */
export class LanguageClass {
  isoCode2: string = '';
  name: string = '';
  idDyn: number | null = null;
  constructor(x: any = {}) {
    this.isoCode2 = x?.isoCode2 ?? '';
    this.name = x?.name ?? '';
    this.idDyn = x?.idDyn ?? null;
  }
}

export class UsersTypeClass {
  name: string = '';
  idDyn: number | null = null;
  noEditable: number | null = null;
  plan: number | null = null;
  constructor(x: any = {}) {
    this.name = x?.name ?? '';
    this.idDyn = x?.idDyn ?? null;
    this.noEditable = x?.noEditable ?? null;
    this.plan = x?.plan ?? null;
  }
}

export class SalePointClass {
  fiscalName: string = '';
  nif: string = '';
  client: { fiscalName: string; nif: string } = { fiscalName: '', nif: '' };
  constructor(x: any = {}) {
    this.fiscalName = x?.fiscalName ?? '';
    this.nif = x?.nif ?? '';
    this.client = {
      fiscalName: x?.client?.fiscalName ?? '',
      nif: x?.client?.nif ?? '',
    };
  }
}

/** ======= PriceList: Params (para pricing) e Infos (texto) ======= */
export class PriceListParamValueClass {
  idDyn: number | null = null;
  name: string = '';
  minRange: number | null = null;
  maxRange: number | null = null;
  constructor(v: any = {}) {
    this.idDyn = v?.idDyn ?? null;
    this.name = v?.name ?? '';
    this.minRange = v?.minRange ?? null;
    this.maxRange = v?.maxRange ?? null;
  }
}

export class PriceListParamClass {
  name: string = '';
  paramType: string = '';
  idDyn: number | null = null;
  /** <-- NOVO */
  plan: number | null = null;
  priceListParamsValues: PriceListParamValueClass[] = [];

  constructor(pp: any = {}) {
    this.name = pp?.name ?? '';
    this.paramType = pp?.paramType ?? '';
    this.idDyn = pp?.idDyn ?? null;
    /** <-- NOVO */
    this.plan = pp?.plan ?? null;
    const vals = Array.isArray(pp?.priceListParamsValues) ? pp.priceListParamsValues : [];
    this.priceListParamsValues = vals.map((v: any) => new PriceListParamValueClass(v));
  }
}

export class InfoTypeClass {
  idDyn: number | null = null;
  name: string = '';
  icon: string = '';
  constructor(x: any = {}) {
    this.idDyn = x?.idDyn ?? null;
    this.name = x?.name ?? '';
    this.icon = x?.icon ?? '';
  }
}

export class PriceListInfoClass {
  infoType: InfoTypeClass | null = null; // no JSON é objeto { idDyn, name, icon }
  plan: number | null = null;
  info: string = '';
  description: string = '';
  constructor(pi: any = {}) {
    this.infoType = pi?.infoType ? new InfoTypeClass(pi.infoType) : null;
    this.plan = pi?.plan ?? null;
    this.info = pi?.info ?? '';
    this.description = pi?.description ?? '';
  }
}

/** ======= Produto / Policy ======= */
export class ProductClass {
  idDyn: number | null = null;
  name: string = '';
  productName: string = '';
  backgroundPath: string = '';
  logoPath: string = '';
  priceList: PriceListClass | null = null;

  constructor(product: any = {}) {
    this.idDyn = product?.idDyn ?? null;
    this.name = product?.name ?? '';
    this.productName = product?.productName ?? '';
    this.backgroundPath = product?.backgroundPath ?? '';
    this.logoPath = product?.logoPath ?? '';
    this.priceList = product?.priceList ? new PriceListClass(product.priceList) : null;
  }
}

export class PriceListClass {
  priceListInfoList: any[] = [];
  priceListParamsList: any[] = [];

  // ? NOVO: períodos válidos para datas (diretamente do payload)
  // Ex.: [{ initialDate: "2025-10-01", finalDate: "2025-12-31" }, ...]
  priceListPeriodList: Array<{ initialDate: string; finalDate: string }> = [];

  constructor(data: any = {}) {
    this.priceListInfoList = data?.priceListInfoList ?? [];
    this.priceListParamsList = data?.priceListParamsList ?? [];

    // aceita tanto "priceListPeriodList" como possíveis variantes
    this.priceListPeriodList =
      data?.priceListPeriodList ??
      data?.periodList ?? // fallback defensivo
      [];
  }
}

export class PolicyLabelClass {
  idDyn: number | null = null;
  name: string = '';
  constructor(x: any = {}) {
    this.idDyn = x?.idDyn ?? null;
    this.name = x?.name ?? '';
  }
}

export class PolicyClass {
  idDyn: number | null = null;
  policyNumber: string = '';
  policyType: string = '';
  productName: string = '';
  isActive: boolean = false;
  product: ProductClass | null = null;
  policyLabel: PolicyLabelClass | null = null;

  constructor(policy: any = {}) {
    this.idDyn = policy?.idDyn ?? null;
    this.policyNumber = policy?.policyNumber ?? '';
    this.policyType = policy?.policyType ?? '';
    this.product = policy?.product ? new ProductClass(policy.product) : null;
    this.productName = policy?.productName ?? policy?.product?.productName ?? policy?.product?.name ?? '';
    this.isActive = Boolean(policy?.isActive);
    // policyLabel vem dentro de policy
    this.policyLabel = policy?.policyLabel ? new PolicyLabelClass(policy.policyLabel) : null;
  }
}

/** ======= (Opcional) Estrutura de utilizador para outras rotas ======= */
export class UserPolicyClass {
  idDyn: number | null = null;
  documentType: string = '';
  documentNumber: string = '';
  language: LanguageClass | null = null;
  usersType: UsersTypeClass | null = null;
  title: string = '';
  name: string = '';
  surname: string = '';
  birthDate: Date | null = null;
  salePoint: SalePointClass | null = null;
  policies: PolicyClass[] = [];

  constructor(user: any = {}) {
    this.idDyn = user?.idDyn ?? null;
    this.documentType = user?.documentType ?? '';
    this.documentNumber = user?.documentNumber ?? '';
    this.title = user?.title ?? '';
    this.name = user?.name ?? '';
    this.surname = user?.surname ?? '';
    this.birthDate = user?.birthDate ? new Date(user.birthDate) : null;
    this.language = user?.language ? new LanguageClass(user.language) : null;
    this.usersType = user?.usersType ? new UsersTypeClass(user.usersType) : null;
    this.salePoint = user?.salePoint ? new SalePointClass(user.salePoint) : null;

    const list = Array.isArray(user?.usersPolicyList) ? user.usersPolicyList : [];
    this.policies = list.map((p: any) => new PolicyClass(p?.policy)).filter((p: PolicyClass) => !!p.idDyn);
  }
}

/** ======= Payloads de POST (classes) ======= */
export class PricingDetailsClass {
  coverageExtensions: any[] = [];
  quotePresetList: Array<{
    paxNum: number | string;
    priceListParamsValues1?: { idDyn: number };
    priceListParamsValues2?: { idDyn: number };
    insuredAmount?: number | null;
    basePrices?: { idDyn: number };
    [k: string]: any;
  }> = [];
}

export class InsuranceRequestClass {
  origin: string = 'INT';
  id: number | null = null;
  version: number | null = null;
  effectDate: string = ''; // YYYY-MM-DD
  unsuscribeDate: string | null = null;
  policy: { idDyn: number; policyNumber?: string; product?: { idDyn: number; productName?: string } } = { idDyn: 0 };
  salePoint: { idDyn: number } | null = null;
  quotePresetList: PricingDetailsClass['quotePresetList'] = [];
  insuranceInsuredList: any[] = [];
  [k: string]: any;
}

export class PaymentRequestClass {
  origin: string = 'INT';
  requestBody: any;
  constructor(x: any = {}) {
    this.origin = x?.origin ?? 'INT';
    this.requestBody = x?.requestBody ?? {};
  }
}

// ------------------------------------------------------------------
// TIPOS p/ Budget
export interface BudgetRequest {
  origin: string; // 'INT'
  effectDate: string; // YYYY-MM-DD
  unsuscribeDate: string; // YYYY-MM-DD (ortografia IM)
  insuranceDetails: any;

  // opcionais aceites pelo backend
  idUserLogged?: number;
  totalAmount?: number; // retailPriceAmount
  netRetailPrice?: number; // netPremiumAmount
  insuredAmount?: number; // Para evitar erro java.math.BigDecimal.toString()
}

export interface BudgetResponse {
  id?: number | string;
  bookingReference1?: string;
  paymentUrl?: string; // depende do endpoint
  [k: string]: any;
}
// ------------------------------------------------------------------

export type IMMappingRow = {
  productIdDyn: number;
  policyNumber: string | null;
  comments: string | null; // normalmente o nome do produto IM
  idProductsTypes: number | null;
  active: 0 | 1;
  dateStart: string;
};

// --- Tipos utilitários (traduções / país / província) ---
export type Translation = {
  name: string;
  language?: { isoCode2?: string };
};

export interface Province {
  idDyn: number;
  name: string;
}

export interface Country {
  idDyn: number;
  name: string;
  isoCode2: string;
  isoCode3?: string;
  translationsList?: Translation[];
  provinceList?: Province[];
}

// --- Detalhes por apólice (para simulação em lote) ---
export type PolicyDetails = {
  p: PolicyClass; // <- já existe neste ficheiro
  product: ProductClass | null; // <- já existe neste ficheiro
  params: PriceListParamClass[]; // <- já existe neste ficheiro
  ambitoParam?: PriceListParamClass;
  durParam?: PriceListParamClass;
  addonParams: PriceListParamClass[];
  coverageOptions: Array<{ id: number | string; name: string }>;
  periods: Array<{ start: Dayjs; end: Dayjs }>;
  maxDurationDays: number | null;
};

// --- Card de proposta (para o grid de resultados) ---
export interface IntermundialProposals {
  policyId: number;
  policyNumber?: string | null;
  productIdDyn?: number | null;
  productName?: string | null;
  idProductsTypes?: number | null;

  // preços na raiz
  retailPriceAmount?: number | null; // total
  paxRetailPrice?: number | null; // por pessoa
  netPremiumAmount?: number | null;
  netRetailPrice?: number | null;

  // meta mínima do pricing
  priceListId?: number | null;
  basePricesIdDyn?: number | null;
  isFlatRate?: boolean;
  isPaymentLetter?: boolean;

  // copy de marketing/resumo
  bullets?: string[];
  coverageMap?: Array<[string, string]>;

  // === Campos equivalentes ao ProposalCard (para a UI) ===
  name?: string; // alias para productName quando necessário
  addons?: PriceListParamClass[]; // opções adicionais do produto
  pricing?: IntermundialPricingResponse; // objeto completo de pricing (se existir)
  currency?: string; // moeda do pricing
  loading?: boolean; // estado de carregamento na UI
  error?: string | null; // mensagem de erro na UI
  // ?? manter só a resposta completa aqui

  // podes manter meta se precisares
  policyMeta?: IntermundialPolicyMeta;

  links?: {
    intermundialLocator?: string;
    budgetId?: string | number;
    paymentUrl?: string;
  };
}

export type UnionAddon = { name: string; values: string[] };
// --- Eventos de debug ---
export type DebugEventType =
  | 'brands'
  | 'brands_req'
  | 'countries'
  | 'countries_req'
  | 'usersPolicies'
  | 'policy'
  | 'policy_req'
  | 'pricing'
  | 'pricing_req'
  | 'budget'
  | 'budget_req'
  | 'payment'
  | 'payment_req'
  | 'postInsurance'
  | 'postInsurance_req'
  | 'postInsurancePayment'
  | 'postInsurancePayment_req'
  | 'simulate'
  | 'simulate_req'
  | 'resolveTypes'
  | 'resolveTypes_req'
  | 'learnTypes'
  | 'learnTypes_req'
  | 'typeMappings'
  | 'setTypeMapping'
  | 'setTypeMapping_req';

export type ResolvedType = {
  productIdDyn: number;
  idProductsTypes: number;
  policyNumber?: string | null;
};

// (opcional) helper para tipar eventos de debug
export type DebugEvent<T = unknown> = {
  when: string;
  type: DebugEventType;
  payload: T;
  error?: boolean;
};
